import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminUnitsDetails from "./AdminUnitsDetails";

class AdminUnitsDetailsModal extends Component {
  render() {
    const { unitId, showUnitDetailsModal, toggleUnitDetailsModal } = this.props;
    const closeBtn = (
      <button className="close" onClick={toggleUnitDetailsModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <Modal
        isOpen={showUnitDetailsModal}
        toggle={toggleUnitDetailsModal}
        className={this.props.className}
        size={"lg"}
        fade={false}
      >
        <ModalHeader
          toggle={toggleUnitDetailsModal}
          className="bg-info text-white"
          close={closeBtn}
        >
          <FontAwesomeIcon icon="info-circle" className="fa-fw mr-2" />
          Unit Details
        </ModalHeader>
        <ModalBody>
          <AdminUnitsDetails unitId={unitId} showEdit={false} />
        </ModalBody>
        <ModalFooter className="bg-lightgray">
          <div className="form-row form-group float-right mb-0">
            <button
              type="button"
              name="closeUnitDetails"
              id="closeUnitDetails"
              className="btn btn-secondary"
              onClick={toggleUnitDetailsModal}
            >
              Close
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default AdminUnitsDetailsModal;
